import React, { createContext, useContext, useState } from "react";

const ScrollContext = createContext(null);

// this help us set the element where we want to scroll to after it is rendered with its ID in the scrolLFlag
// and the scrollToHash function will scroll to that element when it is rendered
const ScrollContextProvider = ({ children }) => {
  const [scrollFlag, setScrollFlag] = useState(null);

  return <ScrollContext.Provider value={{ scrollFlag, setScrollFlag }}>{children}</ScrollContext.Provider>;
};

const useScrollContext = () => {
  const context = useContext(ScrollContext);
  if (context === undefined) {
    throw new Error("useScrollContext must be used within a ScrollContextProvider");
  }
  return context;
};

export { ScrollContextProvider, useScrollContext };
